module.exports = __webpack_public_path__ + "img/img-playlist-default-l.e316b864.png";